/**
 * Методы для работы с событиями по рекламным баннерам.
 */
let EventAdvertising = {
    /**
     * CSS селектор для блоков баннеров, по которым нужно отслеживать события аналитики
     */
    bannerClassSelector: "js-track-banner-stat",
    /**
     * Массив идентификаторов баннеров, которые были показаны на странице.
     * Используется для аналитики рекламных баннеров.
     * Фиксируется только один показ баннера. Когда баннеры идут по второму кругу - их показ уже не нужно фиксировать.
     */
    arViewedBanners: [],
    /**
     * Название куки, в которой храним список баннеров, кликнутых клиентом.
     * Храним только последние 50 кликнутых баннеров. Более старые удаляются при клике на более новых.
     * После совершения заказа список кликнутых баннеров очищается.
     */
    clickedBannersCookie: "BITRIX_SM_clickedBanners",
    /**
     * Массив идентификаторов баннеров, по которым кликал клиент.
     * Массив инициализируется данными из cookie, далее массив дополняется и опять сохраняется в cookie.
     */
    arClickedBannerIds: null,
    /**
     * Стартовый метод, который навешивает все необходимые обработчики событий
     */
    init: function () {
        "use strict";

        // Получить все объекты рекламных блоков по селектору.
        const advBlocks = document.querySelectorAll("." + this.bannerClassSelector);
        Array.prototype.forEach.call(advBlocks, function (advBlock) {
            const obBannerData = window.obMarkadv.eventAdvertising.getBannerData(advBlock);
            if (obBannerData.bannerId > 0) {
                if (
                    "init" === obBannerData.bannerViewEvent
                    && (
                        !window.obMarkadv.eventAdvertising.arViewedBanners.length
                        || window.obMarkadv.eventAdvertising.arViewedBanners.indexOf(obBannerData.bannerId) === -1
                    )
                ) {
                    // Отправляем событие просмотра баннерам, которые настроены на отправку сразу при загрузке страницы.
                    // Проверили, что такого элемента еще нет среди обработанных ранее.
                    window.obMarkadv.eventAdvertising.sendBannerViewEvent(
                        obBannerData.bannerId,
                        obBannerData.bannerSource,
                        window.regionId,
                        document.location.pathname
                    );
                }

                // На все отслеживаемые баннер навешиваем отслеживание клика
                advBlock.addEventListener("click", function (event) {
                    window.obMarkadv.eventAdvertising.sendBannerClickEvent(
                        obBannerData.bannerId,
                        obBannerData.bannerSource,
                        window.regionId,
                        document.location.pathname
                    );
                });
            }
        });

        // При переключении слайдера баннеров на главной странице сайта
        document.addEventListener("viewMainSlider", function (event) {
            if (event.detail.hasOwnProperty("bannerId") && event.detail.bannerId > 0) {
                let bannerSource = "advertising";
                if (
                    event.detail.hasOwnProperty("bannerSource")
                    && "iblock_section_banners" === event.detail.bannerSource
                ) {
                    bannerSource = event.detail.bannerSource;
                }
                window.obMarkadv.eventAdvertising.sendBannerViewEvent(
                    parseInt(event.detail.bannerId),
                    bannerSource,
                    window.regionId,
                    document.location.pathname
                );
            }
        });
    },
    /**
     * Метод возвращает объект со всеми данными рекламного баннера из данных data-атрибутов переданного элемента DOM.
     */
    getBannerData: function (bannerDataElement) {
        "use strict";

        let result = {};
        if (!!bannerDataElement) {
            let bannerId = null;
            if (bannerDataElement.dataset.hasOwnProperty("id")) {
                bannerId = parseInt(bannerDataElement.dataset.id);
            }

            /**
             * Источником баннера на страницах сайта может быть:
             * "advertising" - битриксовые баннеры (по-умолчанию)
             * "iblock_section_banners" - баннеры инфоблока [Контент / Блоки на страницах / Баннеры в разделах]
             *
             * @type {string}
             */
            let bannerSource = "advertising";
            if (
                bannerDataElement.dataset.hasOwnProperty("bannerSource")
                && "iblock_section_banners" === bannerDataElement.dataset.bannerSource
            ) {
                bannerSource = bannerDataElement.dataset.bannerSource;
            }

            /**
             * Переменная содержит код момента, когда надо отправлять событие просмотра баннера. Возможные варианты:
             * "init" - сразу при загрузке страницы (это вариант по-умолчанию)
             * "event" - по какому-то отдельному событию (нужно предусмотреть событие и его обработку)
             * "viewOnScreen" - в момент, когда блок баннера попадает в оле видимости в браузере
             *
             * @type {string|null}
             */
            let bannerViewEvent = "init";
            if (
                bannerDataElement.dataset.hasOwnProperty("bannerViewEvent")
                && (
                    "init" === bannerDataElement.dataset.bannerViewEvent
                    || "event" === bannerDataElement.dataset.bannerViewEvent
                    || "viewOnScreen" === bannerDataElement.dataset.bannerViewEvent
                )
            ) {
                bannerViewEvent = bannerDataElement.dataset.bannerViewEvent;
            }

            result = {
                bannerId: bannerId,
                bannerSource: bannerSource,
                bannerViewEvent: bannerViewEvent,
                isAdvBanner: bannerDataElement.classList.contains("js-show-adv-label")
            }
        }

        return result;
    },
    /**
     * Функция подготавливает данные для отправки события просмотра баннера
     *
     * @param {integer} bannerId     Идентификатор баннера
     * @param {string}  bannerSource Источник баннера (где заведён)
     * @param {integer} regionId     Идентификатор региона
     * @param {string}  url          URL, где произошло событие
     */
    sendBannerViewEvent: function (bannerId, bannerSource, regionId, url) {
        "use strict";

        if (
            bannerId > 0
            && !!bannerSource
            && regionId > 0
            && !!url
            && !BX.util.in_array(bannerId, window.obMarkadv.eventAdvertising.arViewedBanners)
        ) {
            window.obMarkadv.eventAdvertising.arViewedBanners.push(bannerId);

            window.BX.ajax.runAction(
                "intaro:markadv.PublicPage.setEvent",
                {
                    data: {
                        userRegionId: regionId,
                        eventType: "view",
                        sourceBanner: bannerSource,
                        bannerId: bannerId,
                        url: url,
                        source: "site_sp"
                    }
                }
            );
        }
    },
    /**
     * Функция подготавливает данные для отправки события клика баннера
     *
     * @param {integer} bannerId     Идентификатор баннера
     * @param {string}  bannerSource Источник баннера (где заведён)
     * @param {integer} regionId     Идентификатор региона
     * @param {string}  url          URL, где произошло событие
     */
    sendBannerClickEvent: function (bannerId, bannerSource, regionId, url) {
        "use strict";

        if (bannerId > 0 && !!bannerSource && regionId > 0 && !!url) {
            // Запоминаем в куках браузера, что был клик по такому-то баннеру
            window.obMarkadv.eventAdvertising.initClickedBanners();
            if (window.obMarkadv.eventAdvertising.arClickedBannerIds.indexOf(bannerId) === -1) {
                window.obMarkadv.eventAdvertising.arClickedBannerIds.push(bannerId);
                // Сохраняем в куке 50 последних кликнутых баннеров
                const last50 = window.obMarkadv.eventAdvertising.arClickedBannerIds.slice(-50);
                if (!!last50) {
                    setCookie(
                        window.obMarkadv.eventAdvertising.clickedBannersCookie,
                        last50.join(),
                        {secure: true, "max-age": 259200}
                    );
                }
            }

            window.BX.ajax.runAction(
                "intaro:markadv.PublicPage.setEvent",
                {
                    data: {
                        userRegionId: regionId,
                        eventType: "click",
                        sourceBanner: bannerSource,
                        bannerId: bannerId,
                        url: url,
                        source: "site_sp"
                    }
                }
            );
        }
    },
    /**
     * Инициализация глобальной переменной по данным из куки.
     * Формируем переменную со списком баннеров, по которым кликал клиент.
     */
    initClickedBanners: function () {
        "use strict";

        if (null === window.obMarkadv.eventAdvertising.arClickedBannerIds) {
            // Массив идентификаторов просмотренных товаров ещё не инициализировался. Проинициализируем его.
            window.obMarkadv.eventAdvertising.arClickedBannerIds = [];
            const strClickedBannerIds = getCookie(window.obMarkadv.eventAdvertising.clickedBannersCookie);
            const tmpClickedBannerIds = strClickedBannerIds ? strClickedBannerIds.split(",") : [];
            tmpClickedBannerIds.forEach(function (bannerId) {
                bannerId = parseInt(bannerId);
                if (bannerId > 0 && window.obMarkadv.eventAdvertising.arClickedBannerIds.indexOf(bannerId) === -1) {
                    window.obMarkadv.eventAdvertising.arClickedBannerIds.push(bannerId);
                }
            });
        }
    }
}

export {
    EventAdvertising
}
